export const pdfUploadCopy = {
  ru: {
    title: 'Заполнить данные из PDF',
    description: 'Загрузите выписку финансовой устойчивости с Госзакупок — показатели сохранятся в профиле для расчётов.',
    choose: 'Выбрать PDF',
    drop: 'или перетащите файл в этот блок',
  },
  kk: {
    title: 'Деректерді PDF файлынан толтыру',
    description: 'Мемлекеттік сатып алу порталынан қаржылық тұрақтылық туралы үзінді жүктеңіз — көрсеткіштер есептеулер үшін профильде сақталады.',
    choose: 'PDF таңдау',
    drop: 'немесе файлды осы аймаққа сүйреп әкеліңіз',
  },
};
